import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bb3b8be"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb3b8be')) {
      api.createRecord('6bb3b8be', component.options)
    } else {
      api.reload('6bb3b8be', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bb3b8be", function () {
      api.rerender('6bb3b8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/classManage/index.vue"
export default component.exports